import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetEventDistributions,
  useCreateDistributionAnnouncement,
  useDeleteDistribution,
  useSendDistributionEmails,
} from "../api/user";
import DocumentFileNamesTable from "../components/UserDocuments/DocumentFileNamesTable";
import { useDeleteConfirm } from "../hooks/useDeleteConfirm";
import { useConfirm } from "../hooks/useConfirm";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";

export default function DocumentFileNames() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const eventId = currentWorkspace?.eventId;
  const navigate = useNavigate();

  const { data: distributions, isPending } = useGetEventDistributions(eventId);
  const { mutate: createAnnouncement, isPending: isCreatingAnnouncement } =
    useCreateDistributionAnnouncement(eventId);

  const { mutate: sendEmails, isPending: isSendingEmails } =
    useSendDistributionEmails(eventId);
  const confirm = useConfirm();
  const confirmSendEmails = (row) =>
    confirm({
      title: "Send emails?",
      message: `Email ${row.count} recipient${
        row.count === 1 ? "" : "s"
      } a link that opens their document without signing in.`,
      confirmLabel: "Send",
      onConfirm: () => sendEmails({ distributionId: row.id }),
    });

  const { mutate: deleteDistribution } = useDeleteDistribution(eventId);
  const confirmDelete = useDeleteConfirm("distribution", deleteDistribution, {
    modalTitle: "Delete distribution?",
    message:
      "This permanently deletes all files in this distribution and cannot be undone.",
    confirmLabel: "Delete",
  });

  return (
    <DocumentFileNamesTable
      data={distributions}
      isPending={isPending}
      onSelect={(id) => navigate(String(id))}
      onCreateAnnouncement={(distributionId) =>
        createAnnouncement({ distributionId })
      }
      onOpenAnnouncement={(announcementId) =>
        navigate(`/app/announcements/${announcementId}`)
      }
      onSendEmails={confirmSendEmails}
      onOpenEmails={(id) => navigate(`${id}/emails`)}
      onDelete={(row) => confirmDelete({ distributionId: row.id })}
      isCreatingAnnouncement={isCreatingAnnouncement}
      isSendingEmails={isSendingEmails}
    />
  );
}
